module.exports = __webpack_public_path__ + "static/media/img_promotion_1.bd71697f.png";